import { render, staticRenderFns } from "./File.vue?vue&type=template&id=7bf0eaae&scoped=true&"
import script from "./File.vue?vue&type=script&lang=js&"
export * from "./File.vue?vue&type=script&lang=js&"
import style0 from "./File.vue?vue&type=style&index=0&id=7bf0eaae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf0eaae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf0eaae')) {
      api.createRecord('7bf0eaae', component.options)
    } else {
      api.reload('7bf0eaae', component.options)
    }
    module.hot.accept("./File.vue?vue&type=template&id=7bf0eaae&scoped=true&", function () {
      api.rerender('7bf0eaae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/File.vue"
export default component.exports